export default __webpack_public_path__ + "static/media/(6).bbd4c969.jpg";